<template>
    <v-dialog v-model="isOpen" width="800" :retain-focus="false">
        <v-card
            elevation="0" 
            class="pa-4"
            flat
            width="800"
        >
            <v-card-title class="">
                <h1 class="font-weight-light primary--text">Contrato</h1>
            </v-card-title>
            <v-card-text>
                <v-card elevation="0" class=" pt-2 px-4 my-1">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Usuario
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-autocomplete 
                            class="pa-4"
                            :items="comerciales" 
                            v-model="account" 
                            item-text="nombreCompleto"
                            item-value="id" 
                            prepend-icon="mdi-account"
                            persistent-hint 
                            label="Empleado" 
                            clearable
                        >
                        </v-autocomplete>
                    </v-row>
                </v-card>
                <v-card elevation="0" class=" pt-2 px-4 my-1">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Tipo de contrato
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-autocomplete
                            class="pa-4"
                            :items="opciones.contractTypes"
                            item-value="encoded"
                            item-text="human"
                            v-model="contract_type"
                            prepend-icon="mdi-clipboard-file-outline"
                            label="Tipo" 
                            clearable
                        >
                        </v-autocomplete>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="pt-2 px-4 my-1">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Nombre
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-text-field
                            class="pa-4"
                            label="Designación del contrato"
                            prepend-icon="mdi-form-textbox"
                            v-model="contract_name"
                        ></v-text-field>
                    </v-row>
                </v-card>
                <div 
                    id="exportForm"
                    @drop="handleFileDrop"
                    class="bg-grey"
                >
                    <v-icon 
                        v-if="files.length" 
                        large 
                        color="red" 
                        class="deleteBtn"
                        @click="clean()"
                    >mdi-delete</v-icon>
                    <v-container
                        fluid 
                        fill-height
                        class="d-flex justify-center align-center"
                    >
                        <div v-if="files.length == 0" class="d-flex flex-column">
                            <v-icon size="100"> mdi-file-sign </v-icon>
                            <div class="text-center overline font-weight-light">
                                Arrastre el archivo con el contrato o haga click para abrir el explorador de archivos
                            </div>
                        </div>
                        <div v-else class="d-flex justify-center">
                            <v-badge class="" color="error" icon="mdi-arrow-up-bold" overlap>
                                <v-icon color="green accent-1" size="100">
                                    mdi-file-document-edit-outline
                                </v-icon>
                                <div class="overline">
                                    <small>{{ files[0].name.slice(0, 15) }}</small>
                                </div>
                                <div class="grey--text overline">
                                    {{ (files[0].size / (1024 * 1024)).toFixed(1) }} MB
                                </div>
                            </v-badge>
                        </div>
                    </v-container>
                    <input
                        :style="files.length ? 'top: 530px' : 'top: 450px'"
                        type="file"
                        name="file-input"
                        @change="handleFileInput"
                    />
                </div>
            </v-card-text>
            <v-card-actions class="mt-4 mb-n4 ">
                <v-spacer></v-spacer>
                <v-btn
                    color="green"
                    :disabled="!files.length || !account || !contract_name || !contract_type"
                    @click="save()"
                    depressed
                    :dark="!(!files.length || !account || !contract_name || !contract_type)"
                >
                    Guardar
                </v-btn>
                <v-btn
                    color="red"
                    text
                    @click="closePaysheetForm()"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        files: [],
        account: null,
        contract_name: null,
        contract_type: null,
        allowedExtensions: ['pdf'],
    }),
    methods: {
        closePaysheetForm() {
            this.$store.commit('storage/userContractsIsOpen', false);
        },
        clean(){
            this.files = [];
        },
        save(){
            let upload = {}
            upload['contract'] = this.files[0];
            upload['account'] = this.account;
            upload['contract_name'] = this.contract_name;
            upload['contract_type'] = this.contract_type;
            this.$store.dispatch('storage/uploadUserContract', upload);
            this.isOpen = false;
        },
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;
            let fileExtention = droppedFiles[0].name.split('.').pop();

            if (!droppedFiles) return;
            else {
                this.files = [];

                    if (this.allowedExtensions.includes(fileExtention)) {
                        this.files.push(droppedFiles[0]);
                    } else {
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    droppedFiles[0].name +
                                    ' no es del tipo correcto',
                            },
                            { root: true }
                        );
                    }
            }
        },
        handleFileInput(e) {
            let files = e.target.files;
            let fileExtention = files[0].name.split('.').pop();

            if (!files) return;
            else {
                this.files = [];

                if (this.allowedExtensions.includes(fileExtention)) {
                    this.files.push(files[0]);
                } else {
                    this.$store.dispatch(
                        'util/showStatusSnackBar',
                        {
                            statusType: 'error',
                            message:
                                'El archivo ' +
                                files[0].name +
                                ' no es del tipo correcto',
                        },
                        { root: true }
                    );
                }
            }
        },
    },
    computed: {
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        isOpen: {
            get() {
                return this.$store.state.storage.userContracts.isOpen;
            },
            set(value) {
                this.$store.commit('storage/userContractsIsOpen', value);
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
    },
}
</script>

<style scoped>
.deleteBtn {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 10px;
}

#exportForm input {
    cursor: pointer;
    opacity: 0;
    width: 100%;
    height: 100%;
    height: 200px;
    position: absolute;
    top: 350px;
    left: 0;
    right: 0;
    bottom: 0;
}

.bg-grey {
    /* background-color: #f5f5f5; */
    border-radius: 10px;
}
</style>